/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Plan_Feature_Free_ImagesInputs */



/**
* | output |
* | --- |
* | "{count} AI images per day" |
*
* @param {Plan_Feature_Free_ImagesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_feature_free_images = /** @type {((inputs: Plan_Feature_Free_ImagesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Feature_Free_ImagesInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} KI-Bilder pro Tag`)
	return /** @type {LocalizedString} */ (`${i?.count} AI images per day`)
});